import axios from "axios";
import { api } from "../config";
import { store } from "..";
import { open_error_modal } from "../slices/Error_Modal/reducer";
import { logoutUser } from "../slices/thunks";

// default
if(window.location.hostname === "localhost"){
  axios.defaults.baseURL = api.API_URL_LOCAL_HOST
}else{
  axios.defaults.baseURL = api.API_URL;

}
// content type
axios.defaults.headers.post["Content-Type"] = "application/json";

// content type
const token = JSON.parse(localStorage.getItem("authUser")) ? JSON.parse(localStorage.getItem("authUser")).token : null;
if(token)
axios.defaults.headers.common["Authorization"] = "Bearer "+ token;

// intercepting to capture errors
axios.interceptors.response.use(
  function (response) {
    return response.data ? response.data : response;
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    let message;


    switch (error.status || error.response.status) {
      case 500:
        message = "Internal Server Error";
        break;
      case 401:
        message = "Invalid credentials";
        store.dispatch(logoutUser());
        window.location.reload();
        break;
      case 422:
      
        
        message = "Invalid credentials";
        store.dispatch(logoutUser());
        window.location.reload();
        break;
      case 404:
        message = "Sorry! the data you are looking for could not be found";
        break;
      default:
        message =
          error.response.data.message ||
          error.response.data.msg ||
          error.message ||
          error.response.data.error ||
          error;
        store.dispatch(open_error_modal(message));
    }
    return Promise.reject(message);
  }
);

const interceptors = (  function (response) {
  return response.data ? response.data : response;
},
function (error) {
  // Any status codes that falls outside the range of 2xx cause this function to trigger
  let message;

  

  
  
  switch (error.status||error.response.status) {
    case 500:
      message = error.message||error.response.data.message||error.response.data.msg|| error.response.data.error || error || "Internal Server Error";
      break;
    case 401:
      message = "Invalid credentials";
      store.dispatch(logoutUser())
      break;
      case 422:
        message = "Invalid credentials";
        store.dispatch(logoutUser())
        break;
    case 404:
      message = "Sorry! the data you are looking for could not be found";
      break;
    default:
      message = error.message||error.response.data.message||error.response.data.msg|| error.response.data.error || error;
      
      
      store.dispatch(open_error_modal(message))
  }
  return Promise.reject(message);
})
/**
 * Sets the default authorization
 * @param {*} token
 */
const setAuthorization = (token) => {
  
  axios.defaults.headers.common["Authorization"] = "Bearer "+ token;

};



class APIClient {
  /**
   * Fetches data from given url
   */

  //  get = (url, params) => {
  //   return axios.get(url, params);
  // };
 



  get = (url, params) => {

    setAuthorization(JSON.parse(localStorage.getItem("authUser")) ? JSON.parse(localStorage.getItem("authUser")).token : null)
    
    
    
    let response;

    let paramKeys = [];

      // console.log(params);
     
      
      response = axios.get(`${url}`, {
        params:params,
        withCredentials: true,
      });
   

    return response;
  };
  /**
   * post given data to url
   */
  create = (url, data) => {
    setAuthorization(JSON.parse(localStorage.getItem("authUser")) ? JSON.parse(localStorage.getItem("authUser")).token : null)
    return axios.post(url, data ,{ 
      withCredentials: true,
    });
  };
 

  // Upload File

  upload_file = (url, data) => {
    setAuthorization(JSON.parse(localStorage.getItem("authUser")) ? JSON.parse(localStorage.getItem("authUser")).token : null)
    return axios.post(url, data , { headers:{
      "Content-Type":"multipart/form-data"
    } , withCredentials: true });
  };

  upload_file_put = (url, data) => {
    setAuthorization(JSON.parse(localStorage.getItem("authUser")) ? JSON.parse(localStorage.getItem("authUser")).token : null)
    return axios.put(url, data , { headers:{
      "Content-Type":"multipart/form-data"
    }});
  };
  /**
   * Updates data
   */
  update = (url, data) => {
    setAuthorization(JSON.parse(localStorage.getItem("authUser")) ? JSON.parse(localStorage.getItem("authUser")).token : null)
    return axios.patch(url, data , { withCredentials: true });
  };

  put = (url, data) => {
    setAuthorization(JSON.parse(localStorage.getItem("authUser")) ? JSON.parse(localStorage.getItem("authUser")).token : null)
    return axios.put(url, data , { withCredentials: true });
  };


  patch = (url, data) => {
    setAuthorization(JSON.parse(localStorage.getItem("authUser")) ? JSON.parse(localStorage.getItem("authUser")).token : null)
    return axios.patch(url, data , { withCredentials: true });
  };
  /**
   * Delete
   */
  delete = (url, config) => {
    setAuthorization(JSON.parse(localStorage.getItem("authUser")) ? JSON.parse(localStorage.getItem("authUser")).token : null)
    return axios.delete(url, { ...config , withCredentials: true });
  };
}
const getLoggedinUser = () => {
  const user = localStorage.getItem("authUser");
  if (!user) {
    return null;
  } else {
    return JSON.parse(user);
  }
};

export { APIClient, setAuthorization, getLoggedinUser };